import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// import UserImage from '../user-image/user-image';
import DialogPanel from '../dialog-panel/dialog-panel';
import DialogPanelBody from '../dialog-panel/dialog-panel-body/dialog-panel-body';
// import './additional-expenses.scss';
import FileItem from '../file-item/file-item';
import DialogPanelFooter from '../dialog-panel/dialog-panel-footer/dialog-panel-footer';
import Button from '../button/button';
import { AcceptBorderedIcon, RejectBorderedIcon } from '../icons/icons';
import Dialog from '../dialog/dialog';
import PanelCard from '../panel-card/panel-card';
import useDialog from '../dialog/useDialog';
import CustomEditor from '../text-editor/custome-texteditor';
import ForwarderUploadDocument from '../create-booking/forwarder-upload-document';
import PanelCardFooter from '../panel-card/panel-card-footer';
// import NewButton from '../button/newButton';
import AdvancePopover from '../advance-popover/advance-popover';
import IconButton from '../icon-button/icon-button';
import UserDetails from '../user-details/user-details';

function ApproveQuotation({ approvaldata, apiCall }) {
  const [t] = useTranslation('managebooking');
  const [t2] = useTranslation('managecustoms');

  const { isShowing: isApprovalNotes, toggle: toggleApprovalNotes } =
    useDialog();
  const [isapprove, setisapprove] = useState(false);

  const documents = approvaldata?.documentLink;

  const [eventValue, setEventValue] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [apiCallPending, setApiCallPending] = useState(false);

  const togglePopover = (e) => {
    setEventValue(e.target);
  };

  const handleClose = () => {
    setEventValue(null);
  };
  const getPlainText = (htmlString) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  const formik = useFormik({
    initialValues: {
      note: '',
      document: [],
    },
    validationSchema: Yup.object({
      note: Yup.string(),
    }),
    onSubmit: (values) => {
      const note = values?.note.replace(/&nbsp;/g, ' ');
      setApiCallPending(true);
      if (isapprove) {
        apiCall(
          'Accepted',
          note,
          values?.document,
          toggleApprovalNotes,
          setApiCallPending
        );
      } else {
        apiCall(
          'Rejected',
          note,
          values?.document,
          toggleApprovalNotes,
          setApiCallPending
        );
      }
    },
  });
  const handleUploadDocument = (id, array) => {
    setAttachments(array);
    formik.setFieldValue('document', array);
  };

  const buttonLabel = () => {
    if (apiCallPending) return t2('quoteApprovalFlow.wait');
    return isapprove
      ? t2('managecustomsscreen.additionalfundsexpenses.approve')
      : t2('managecustomsscreen.additionalfundsexpenses.rejectbutton');
  };

  return (
    <div className="additional-expenses">
      <DialogPanel
        title={t2('quoteApprovalFlow.approveQuoteTitle')}
        large="booking-details-title"
        className="additional-expenses-dialog"
      >
        <DialogPanelBody>
          <div className="req-amount mb-20">
            <div className="w-50">
              <h4 className="amt-title">
                {t2('managecustomsscreen.additionalfundsexpenses.amount')}
              </h4>
              <div className="d-flex align-center">
                <p className="amount">
                  {approvaldata?.totalPrice} {approvaldata?.currency}
                </p>
              </div>
            </div>
            <div className="ml-20 w-40">
              <h4 className="amt-title">
                {t2('managecustomsscreen.additionalfundsexpenses.requester')}
              </h4>
              <div className="d-flex align-center">
                <UserDetails
                  userName={`${approvaldata?.firstName} ${approvaldata?.lastName}`}
                />
                {/* <UserImage
                  name={`${approvaldata?.firstName} ${approvaldata?.lastName}`}
                  shortName={`${approvaldata?.firstName?.[0]}${approvaldata?.lastName?.[0]}`}
                  path={
                    approvaldata?.profilePicture
                      ? approvaldata?.profilePicture
                      : false
                  }
                  removeTooltip
                />
                <h4 className="user-name">{`${approvaldata?.firstName} ${approvaldata?.lastName}`}</h4> */}
              </div>
            </div>
          </div>
          <div className="notes-doc">
            <div className="w-50">
              <h4 className="amt-title">
                {t2('managecustomsscreen.additionalfundsexpenses.notes')}
              </h4>
              <p className="amount">{approvaldata?.reason}</p>
            </div>
            {documents?.length > 0 && (
              <div className="ml-20 w-40">
                <h4 className="amt-title">
                  {t2(
                    'managecustomsscreen.additionalfundsexpenses.supportdocument'
                  )}
                </h4>
                <div className="d-flex align-end">
                  <div className="documents">
                    {documents?.slice(0, 3)?.map((doc, index) => (
                      <a href={doc?.url}>
                        <FileItem
                          key={doc?.docId || index}
                          className="m-0 mr-10"
                          fileName={doc?.originalName}
                          disabledRemove
                          docId={doc?.docId}
                          formatLimit={30}
                        />
                      </a>
                    ))}
                  </div>
                  {documents?.length > 3 && (
                    <div className="show-more mb-5 d-flex">
                      <IconButton
                        className="show-more"
                        id="showMore"
                        placement="self-bottom"
                        onClick={togglePopover}
                        verient="primary"
                      >
                        +{documents.length - 3}
                      </IconButton>
                      <AdvancePopover
                        reference="showMore"
                        closePopover={handleClose}
                        getEvent={eventValue}
                        placement="left"
                        zIndex={10000002}
                        closeOnclick
                      >
                        <div>
                          <ul className="action-list">
                            {documents?.slice(3)?.map((doc, index) => (
                              <li key={doc.docId || index} className="p-0">
                                <a href={doc?.url}>
                                  <FileItem
                                    fileName={doc?.originalName}
                                    docId={doc?.docId}
                                    disabledRemove
                                    formatLimit={30}
                                  />
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </AdvancePopover>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </DialogPanelBody>
        <DialogPanelFooter>
          <>
            <Button
              label={t2('managecustomsscreen.additionalfundsexpenses.accept')}
              type="button"
              onClick={() => {
                toggleApprovalNotes();
                setisapprove(true);
              }}
              icon={<AcceptBorderedIcon />}
              className="accetpt"
            />
            <Button
              label={t2('managecustomsscreen.additionalfundsexpenses.reject')}
              type="button"
              icon={<RejectBorderedIcon />}
              onClick={() => {
                toggleApprovalNotes();
                setisapprove(false);
              }}
              className="reject"
            />
          </>
        </DialogPanelFooter>
      </DialogPanel>

      {/* Accept Dailog */}
      <Dialog
        isShowing={isApprovalNotes}
        hide={() => {
          toggleApprovalNotes();
          setAttachments([]);
        }}
        maskZindex={1041}
      >
        <PanelCard
          cardTitle={
            isapprove
              ? t2('managecustomsscreen.additionalfundsexpenses.approvalnotes')
              : t2('managecustomsscreen.additionalfundsexpenses.rejectionnotes')
          }
          className="w-460"
        >
          <form onSubmit={formik.handleSubmit}>
            <CustomEditor
              disabledSend
              charLimit={250}
              disabledAttach
              disableFontSize
              disableUnderline
              name="note"
              type="text"
              rows="2"
              className="h-100 quatation"
              label=""
              placeholder={
                isapprove
                  ? t2(
                      'managecustomsscreen.additionalfundsexpenses.enterapprovalnotesifany'
                    )
                  : t2(
                      'managecustomsscreen.additionalfundsexpenses.enterrejectionnotes'
                    )
              }
              movetoBottom
              disableAlignment
              getEditorValue={(e) => {
                const plainText = getPlainText(e);
                formik.setFieldValue('note', plainText);
              }}
            />

            <ForwarderUploadDocument
              id="doc"
              handleUploadDocument={handleUploadDocument}
              label={t2(
                'managecustomsscreen.requestadditonalexpenses.uploadsupportdocuments'
              )}
              uploadedAttachement={attachments}
              t={t}
              required={false}
              errorMessage={formik.touched.document && formik.errors.document}
              isRequired={false}
            />

            <PanelCardFooter align="right">
              <Button
                label={t2('managecustomsscreen.additionalfundsexpenses.cancel')}
                color="cancel"
                onClick={() => {
                  toggleApprovalNotes();
                  setAttachments([]);
                }}
                disabled={apiCallPending}
              />
              <Button
                label={buttonLabel()}
                color="submit"
                type="submit"
                disabled={apiCallPending}
              />
            </PanelCardFooter>
          </form>
        </PanelCard>
      </Dialog>
    </div>
  );
}
ApproveQuotation.propTypes = {
  approvaldata: PropTypes.instanceOf(Array).isRequired,
  apiCall: PropTypes.func.isRequired,
};
export default ApproveQuotation;
